import PropTypes from "prop-types"
import React from "react"
import StyleLoaderContainer from "../shared-components/components/StyleLoader/styleLoaderContainer"
import {SERVIDOM_AREA} from "../shared-components/constants/areaTypes"
import sosStyle from "../styles/sosStyle"
import {getDynamicConfigurationValue} from "../store/selectors/localStorage/dynamicConfigurationSelectors"
import {getStyle, areCustomizedStyle} from "../store/selectors/localStorage/styleSelectors"
import {getTexts, isCustomizedTexts} from "../store/selectors/localStorage/textSelector"
import {PagesArchitecture} from "../constants/page/pagesArchitecture"
import {Page} from "../constants/page/pages"
import ErrorBoundaryContainer from "../shared-components/components/ErrorBoundary/errorBoundaryContainer"

const StyleLoaderLayout = ({children, isSmallClient, isSocialContract}) => {
    return (
        <StyleLoaderContainer
            customStyle={sosStyle}
            espaceType={SERVIDOM_AREA}
            getDynamicConfigurationValue={getDynamicConfigurationValue}
            getStyle={getStyle}
            getTexts={getTexts}
            isCustomizedStyle={areCustomizedStyle}
            isCustomizedTexts={isCustomizedTexts}
        >
            <ErrorBoundaryContainer routeToRedirect={PagesArchitecture[Page.HOME].route}>
                {children}
            </ErrorBoundaryContainer>
        </StyleLoaderContainer>
    )
}

StyleLoaderLayout.propTypes = {
    children: PropTypes.node.isRequired,
    isSmallClient: PropTypes.bool.isRequired,
    isSocialContract: PropTypes.bool.isRequired,
}

export default StyleLoaderLayout
